import { useEffect, useState } from "react";

interface TimePickerProps {
    timeSlots?: string[]
    time: string;
    setTime: (value: string) => void;
    restaurantPhone?: string;
    formColor: string;
}

export const TimePicker: React.FC<TimePickerProps> = (props) => {
    const { timeSlots, time, setTime, restaurantPhone, formColor } = props;
    const size = 4;
    const [internalTimeSlots, setInternalTimeSlots] = useState<string[][]>();

    const handleTimeClick = (inst: any) => {
        if (inst.target.innerHTML != '') {
            setTime(inst.target.innerHTML);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        const arr: string[][] = [];
        if (timeSlots) {
            for (let i = 0; i < Math.ceil(timeSlots.length / size); i++) {
                const intArr = [];
                for (let j = 0; j < size; j++) {
                    if (timeSlots[i * size + j])
                        intArr.push(timeSlots[i * size + j] ? (timeSlots[i * size + j].length > 8 ? timeSlots[i * size + j].slice(2,7) : timeSlots[i * size + j].slice(0,5)) : '');
                }
                arr.push(intArr);
            }
            setInternalTimeSlots(arr);
        }
    }, [timeSlots]);
    
    return (
        <div className='picker__container' >
            <div className='picker__slide'>
        {internalTimeSlots?.length == 0 && (
        <h3 className="picker__noentries">На выбранный день отсутствуют свободные временные слоты, но ресторан открыт - попробуйте туда позвонить  { restaurantPhone != undefined ? "по номеру " + restaurantPhone : ""}</h3>
        )}
        {internalTimeSlots?.map((element, index) => {
                return (
                    <div key={'rc' + index}>
                     {index == 0 && (parseInt(element[0].slice(0,2)) < 12) && (<div key={'breakfast' + index} className="picker__row picker__row_partofday">Утро</div>)}
                     {(index == 0 || element[0] == '12:00') && (parseInt(element[0].slice(0,2)) >= 12 && parseInt(element[0].slice(0,2)) < 18) && (<div key={'lunch' + index} className="picker__row picker__row_partofday">День</div>)}
                     {(index == 0 || element[0] == '18:00') && (parseInt(element[0].slice(0,2)) >= 18) && (<div key={'dinner' + index} className="picker__row picker__row_partofday">Вечер</div>)}
                    <div key={'r' + index} className="picker__row">
                        {element.map((childElement, childIndex) => {
                            return (
                                <div
                                style={{width: `${Math.floor(100 / size) - 2}%`, backgroundColor: time == childElement ? formColor : ''}}
                                    key={'e' + index + childIndex}
                                    id={'e' + (index * 7 + childIndex)}
                                    role="presentation"
                                    onClick={handleTimeClick}
                                    className={`picker__element picker__element_time${time == childElement ? ' picker__element_selected' : ''}${childElement == '' ? ' picker__element_empty' : ''}`}>
                                    {childElement}
                                </div>);
                        })}
                    </div>
                    </div>
                );
            })}
        </div>
    </div>);
}